import type { UploadLimitDetails } from './UploadLimitError';

export class DownloadLimitError extends Error {
  public readonly errorCode: string;
  public readonly details: UploadLimitDetails;
  public readonly limitType?: string;

  constructor(errorCode: string, message: string, details: UploadLimitDetails = {}, limitType?: string) {
    super(message);
    this.name = 'DownloadLimitError';
    this.errorCode = errorCode;
    this.details = details;
    this.limitType = limitType;
  }
}
